<template>
  <section class="video-card">
    <div v-if="!showVideo">
      <img
        class="videothump"
        @click="play"
        @mouseenter="showSometing"
        @mouseleave="hiddenSometing"
        :src="item.thumb | imageUrl('', 1460, 822)"
      />
      <!-- <span class="add"></span> -->
      <span class="play" :class="{show:focus}" @mouseenter="showSometing" @click="play">
        <img src="/static/v2/match/play_tri_40.png" alt />
      </span>
      <span
        class="videotime"
        :class="{show:focus}"
        @mouseenter="showSometing"
      >{{item.duration | secondToDate}}</span>
    </div>
    <mana-player
      v-else
      class="video-player"
      :playerOptions="playerOptions"
      ref="manaPlayer"
      :videoId="item.id"
      :isRecommend="isRecommend"
    ></mana-player>
    <router-link target="_blank" :to="'/video/detail?id='+item.videoId">
      <p class="title">{{item.title}}</p>
    </router-link>
    <div class="industryList" v-if="type == 1">
      <!-- <div class="industryListLeft" v-if="language==='zh'">
        <span v-for="it in item.professionList" :key="it.id">{{it.title}}</span>
      </div>
      <div class="industryListLeft" v-if="language!=='zh'">
        <span v-for="it in item.professionList" :key="it.id">{{it.titleEn}}</span>
      </div> -->
      <div class="industryListLeft">
        <span v-for="it in item.categoryTagGroupInfoList" :key="it.id">{{it}}</span>
      </div>
      <div class="userright">
        <img src="/static/v2/article/view_icon.png" />
        <span>{{item.viewCount}}</span>
      </div>
    </div>
  </section>
</template>

<script>
import ManaPlayer from "@/components/video/ManaPlayer";
export default {
  components: {
    ManaPlayer
  },
  data() {
    return {
      isRecommend: true,
      focus: false,
      showVideo: false,
      playerOptions: {
        muted: true,
        language: "zh",
        sources: [
          {
            type: "video/mp4",
            src: ""
          }
        ],
        notSupportedMessage: `${this.$t("global.视频加载中")}，${this.$t(
          "global.请稍后"
        )}...`
      }
    };
  },
  props: ["item", "language","type"],
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const qiniuData = this.item.qiniuData && JSON.parse(this.item.qiniuData);

      if (qiniuData.resource) {
        Object.keys(qiniuData.resource).forEach(key => {
          if (!qiniuData.resource[key].includes("https://")) {
            qiniuData.resource[key] =
              "https://video.manamana.net/" + qiniuData.resource[key];
          }
        });
        this.playerOptions.videoList = qiniuData.resource;
        let img = this.item.thumb,
          img_o = img;
        img_o = this.$jsonUtils.imageUrl(img, null, "", 563);

        this.playerOptions.poster = img_o;
        this.playerOptions.sources = [
          {
            type: "video/mp4",
            src: qiniuData.resource["s720"]
          }
        ];
      }
    },
    play() {
      this.showVideo = true;
      setTimeout(() => {
        this.$refs.manaPlayer.play();
      }, 0);
    },
    goToUser(userId) {
      this.$router.push(`/peopleCenter/${userId}`);
    },
    showSometing() {
      this.focus = true;
    },
    hiddenSometing() {
      this.focus = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
.video-card {
  p.title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #0A0A0A;
    height: 27px;
    padding: 10px 0 5px;
    font-size: 20px;
    font-family: NunitoSans-Bold, NunitoSans;
    font-weight: bold;
  }

  .industryList {
    color: #999;
    line-height: 17px;
    padding: 0;
    overflow: hidden;

    .industryListLeft {
      float: left;
      width: 280px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      span {
        font-size: 15px;
        margin-right: 8px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }

    .userright {
      float: right;
      display: flex;
      align-items: center;

      img {
        position: relative;
        width: 18px;
        height: 12px;
        margin-right: 3px;
      }
    }
  }

  div {
    position: relative;
    display: block;

    .videothump {
      width: 100%;
      height: 411px;
      cursor: pointer;
    }

    .videotime {
      position: absolute;
      display: none;
      top: 375px;
      right: 10px;
      padding: 2px 8px;
      color: #fff;
      background: #0A0A0A;
      border-radius: 2px;
    }

    .play {
      position: absolute;
      display: none;
      left: 342px;
      top: 175px;
      cursor: pointer;

      img {
        width: 46px;
        height: 61px;
      }
    }

    .show {
      display: inline-block;
    }
  }

  .video-player {
    height: 411px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/peopleCenter/VideoCard.vue